import { render, staticRenderFns } from "./DetailsConsigne.vue?vue&type=template&id=035a19a1&scoped=true&"
import script from "./DetailsConsigne.vue?vue&type=script&lang=ts&"
export * from "./DetailsConsigne.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsConsigne.vue?vue&type=style&index=0&id=035a19a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035a19a1",
  null
  
)

export default component.exports